import styled from 'styled-components';

import * as Common from '../../Styles';

const Theme = Common.Theme;

export const InputGroup = styled(Common.InputGroup)``;

export const TextArea = styled(Common.TextArea)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const FilledErrorButton = styled(Common.FilledErrorButton)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)`
	margin-top: -16px !important;
	padding: 1rem !important;
`;

export const CircularButton = styled(Common.CircularButton)``;

export const ReasonChipRow = styled(Common.FlexRow)`
	gap: 0.5rem;
	flex-wrap: wrap;
	margin: 0.5rem 0;
`;

export const ReasonChip = styled(Common.Chip).attrs((props) => ({
	clickable: true,
	variant: props.selected ? 'filled' : 'outlined',
}))`
	border-color: ${Theme.orange} !important;
	color: ${(props) => (props.selected ? Theme.white : Theme.orange)} !important;
	background-color: ${(props) => (props.selected ? Theme.orange : 'transparent')} !important;
`;
